import {IAMSectionResource} from '../../../../shared/types/iam-types/iAMSectionResource';
import {IAMRightsUpdateRequest} from '../../../../shared/types/iam-types/iAMRightsUpdateRequest';
import {
  IAMRightsUpdateRequestRightsInner,
} from '../../../../shared/types/iam-types/iAMRightsUpdateRequestRightsInner';
import {IAMGrant} from '../../../../shared/types/iam-types/iAMGrant';

export function mapSectionRightsToUpdateRequest(sections: IAMSectionResource[], isGroup: boolean): IAMRightsUpdateRequest {
  const rights: IAMRightsUpdateRequestRightsInner[] = [];

  sections
    .flatMap((section) => section.rights)
    .forEach((right) => {
      rights.push({
        id: right.id,
        grant: isGroup ? (right.grant === IAMGrant.Deny ? IAMGrant.Inherit : right.grant ) : right.grant
      });
    });

  return {rights};
};
